(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.sz-cart__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.sz-cart__qty').querySelector('.sz-cart__qty-input');
        var val = parseInt(input.value, 10) || 0;
        val = val + parseInt(btn.dataset.dir, 10);
        if (val < 0) val = 0;
        input.value = val;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var hamburger = document.getElementById('header-hamburger');
    var nav = document.getElementById('header-nav');
    var closeBtn = document.getElementById('header-nav-close');

    function openNav() {
      nav.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      nav.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (hamburger) hamburger.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);

    if (nav) {
      nav.querySelectorAll('.header__nav-link').forEach(function (link) {
        link.addEventListener('click', closeNav);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sz-cart-drawer"]) return;
  try {
    
  (function () {
    var overlay = document.getElementById('sz-cart-overlay');
    var drawer  = document.getElementById('sz-cart-drawer');
    var closeBtn = document.getElementById('sz-cart-close');

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function openDrawer() {
      if (!drawer || !overlay) return;
      loadCart();
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function loadCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); })
        .catch(function () {
          var body = document.getElementById('sz-cart-body');
          if (body) body.innerHTML = '<p class="sz-cart-drawer__empty">Impossible de charger le panier.</p>';
        });
    }

    function updateBadge(count) {
      var badge = document.getElementById('sz-cart-badge');
      if (!badge) return;
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    }

    function renderCart(cart) {
      var body    = document.getElementById('sz-cart-body');
      var footer  = document.getElementById('sz-cart-footer');
      var countEl = document.getElementById('sz-cart-count');

      if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      updateBadge(cart.item_count);

      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<p class="sz-cart-drawer__empty">Ton panier est vide.</p>';
        if (footer) footer.innerHTML = '';
        return;
      }

      body.innerHTML = cart.items.map(function (item) {
        var imgUrl       = item.featured_image ? item.featured_image.url : '';
        var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        return '<div class="sz-cart-drawer__item">' +
          (imgUrl ? '<img class="sz-cart-drawer__img" src="' + imgUrl + '" alt="" width="72" height="72" loading="lazy">' : '') +
          '<div class="sz-cart-drawer__item-info">' +
            '<p class="sz-cart-drawer__item-title">' + item.product_title + '</p>' +
            (variantLabel ? '<p class="sz-cart-drawer__item-variant">' + variantLabel + '</p>' : '') +
            '<div class="sz-cart-drawer__item-row">' +
              '<span class="sz-cart-drawer__item-qty">Qté : ' + item.quantity + '</span>' +
              '<span class="sz-cart-drawer__item-price">' + formatMoney(item.line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="sz-cart-drawer__remove" data-key="' + item.key + '" aria-label="Supprimer">✕</button>' +
        '</div>';
      }).join('');

      body.querySelectorAll('.sz-cart-drawer__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = this.getAttribute('data-key');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function () { loadCart(); });
        });
      });

      if (footer) {
        footer.innerHTML =
          '<div class="sz-cart-drawer__total">' +
            '<span>Total</span>' +
            '<strong>' + formatMoney(cart.total_price) + '</strong>' +
          '</div>' +
          '<a href="/checkout" class="sz-cart-drawer__checkout">Commander →</a>' +
          '<a href="/cart" class="sz-cart-drawer__view-cart">Voir le panier complet</a>';
      }
    }

    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#sz-cart-icon-btn');
      if (btn) { e.preventDefault(); openDrawer(); }
    });

    document.addEventListener('cart:open', openDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sz-packs"] && !Shopify.designMode) return;
  try {
    
  (function () {

    /* ---------------------------------------------------------------
       Chargement des variantes de semelle-stepzero-padel depuis le JSON embarqué.
       Tableau plat — la quantité varie par pack (1, 2 ou 3).
    --------------------------------------------------------------- */
    var allVariants = [];
    try {
      var raw = document.getElementById('sz-packs-variants');
      if (raw) allVariants = JSON.parse(raw.textContent);
    } catch (e) {}

    /* --- Références DOM de la modal --- */
    var modal        = document.getElementById('sz-pm');
    var modalLabel   = document.getElementById('sz-pm-label');
    var modalGrid    = document.getElementById('sz-pm-grid');
    var modalError   = document.getElementById('sz-pm-error');
    var modalClose   = document.getElementById('sz-pm-close');
    var modalConfirm = document.getElementById('sz-pm-confirm');

    /* Quantité et variante sélectionnées */
    var currentQty        = 1;
    var selectedVariantId = null;

    /* ---------------------------------------------------------------
       szPackModal(btn) — ouverture de la modal
       data-quantity="1|2|3"         → quantité à ajouter au panier
       data-pack-label="Pack Duo …"  → titre affiché dans la modal
    --------------------------------------------------------------- */
    window.szPackModal = function (btn) {
      currentQty = parseInt(btn.dataset.quantity, 10) || 1;

      /* Si le produit n'est pas configuré → fallback page produit */
      if (!allVariants.length) {
        window.location.href = '/products/semelle-stepzero-padel';
        return;
      }

      /* Réinitialisation */
      selectedVariantId = null;
      if (modalError) modalError.style.display = 'none';
      if (modalConfirm) { modalConfirm.textContent = 'Ajouter au panier →'; modalConfirm.disabled = false; }

      /* Label du pack */
      if (modalLabel) modalLabel.textContent = btn.dataset.packLabel || '';

      /* Génération des boutons de taille depuis les variantes Shopify */
      if (modalGrid) {
        modalGrid.innerHTML = '';
        allVariants.forEach(function (v) {
          var sizeName = v.option1 || v.title; /* option1 = première option (Taille) */
          var sizeBtn  = document.createElement('button');
          sizeBtn.type = 'button';
          sizeBtn.className = 'sz-pm__size-btn';
          sizeBtn.textContent = sizeName;
          sizeBtn.dataset.variantId = v.id;

          if (!v.available) {
            sizeBtn.disabled = true;
            sizeBtn.classList.add('sz-pm__size-btn--sold');
          }

          sizeBtn.addEventListener('click', function () {
            /* Désélection de tous les boutons */
            modalGrid.querySelectorAll('.sz-pm__size-btn').forEach(function (b) {
              b.classList.remove('sz-pm__size-btn--active');
            });
            sizeBtn.classList.add('sz-pm__size-btn--active');
            selectedVariantId = v.id;
            if (modalError) modalError.style.display = 'none';
          });

          modalGrid.appendChild(sizeBtn);
        });
      }

      /* Ouverture */
      if (modal) { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    };

    /* --- Fermeture --- */
    function closeModal() {
      if (modal) { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    }

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    /* ---------------------------------------------------------------
       Ajout au panier via l'API AJAX Shopify
       POST /cart/add.js — { id: variantId, quantity: currentQty }
       Essentiel = 1 × semelle | Duo = 2 × semelle | Performance = 3 × semelle
    --------------------------------------------------------------- */
    modalConfirm && modalConfirm.addEventListener("click", async function () {
      if (!selectedVariantId) {
        if (modalError) modalError.style.display = "block";
        return;
      }
      modalConfirm.textContent = "Ajout en cours…";
      modalConfirm.disabled = true;
      try {
        var res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: selectedVariantId, quantity: currentQty }),
        });
        if (res.ok) {
          closeModal();
          document.dispatchEvent(new CustomEvent("cart:open"));
        } else {
          var errData = await res.json();
          if (modalError) {
            modalError.textContent = "⚠️ " + (errData.description || "Produit indisponible.");
            modalError.style.display = "block";
          }
          modalConfirm.textContent = "Ajouter au panier →";
          modalConfirm.disabled = false;
        }
      } catch (e) {
        if (modalError) {
          modalError.textContent = "⚠️ Erreur réseau. Réessaie.";
          modalError.style.display = "block";
        }
        modalConfirm.textContent = "Ajouter au panier →";
        modalConfirm.disabled = false;
      }
    });

    /* ---------------------------------------------------------------
       Carousel dots (mobile seulement)
    --------------------------------------------------------------- */
    if (window.innerWidth > 640) return;
    var grid  = document.getElementById('sz-home-packs');
    var dotsEl = document.getElementById('sz-home-packs-dots');
    if (!grid || !dotsEl) return;
    var dots = Array.from(dotsEl.querySelectorAll('.sz-dot'));

    function updateDots() {
      var gLeft = grid.getBoundingClientRect().left;
      var idx = 0, minDist = Infinity;
      Array.from(grid.children).forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - gLeft);
        if (d < minDist) { minDist = d; idx = i; }
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('sz-dot--active', i === idx); });
    }

    grid.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var child = grid.children[i];
        if (child) child.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sz-product-benefits"]) return;
  try {
    
  (function () {
    if (window.innerWidth > 768) return;
    var grid = document.getElementById('sz-prod-benefits');
    var dotsEl = document.getElementById('sz-prod-benefits-dots');
    if (!grid || !dotsEl) return;
    var dots = Array.from(dotsEl.querySelectorAll('[data-dot]'));
    var items = Array.from(grid.querySelectorAll('[data-carousel-item]'));
    function updateDots() {
      if (!items.length) return;
      var itemWidth = items[0].offsetWidth + 16;
      var idx = Math.round(grid.scrollLeft / itemWidth);
      idx = Math.max(0, Math.min(idx, dots.length - 1));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('sz-dot--active', i === idx);
        dot.style.opacity = i === idx ? '1' : '0.3';
      });
    }
    grid.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var child = items[i];
        if (child) child.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sz-product-hero"]) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-section-id]');
    if (!section) return;

    // Thumbnail switching (image + video)
    const mainImg   = document.getElementById('szph-main-img');
    const mainVideo = document.getElementById('szph-main-video');
    const thumbs    = document.querySelectorAll('.szph__thumb');

    function showImage(src, alt) {
      if (mainVideo) { mainVideo.pause(); mainVideo.style.display = 'none'; }
      if (mainImg)   { mainImg.style.display = ''; }
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = src;
          mainImg.alt = alt;
          mainImg.style.opacity = '1';
        }, 150);
      }
    }

    function showVideo(src, poster) {
      if (mainImg) mainImg.style.display = 'none';
      if (mainVideo) {
        mainVideo.style.display = 'block';
        if (poster) mainVideo.poster = poster;
        mainVideo.src = src;
        mainVideo.load();
        mainVideo.play().catch(function () {});
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('szph__thumb--active'); });
        thumb.classList.add('szph__thumb--active');
        var mediaType = thumb.dataset.mediaType;
        if (mediaType === 'video') {
          showVideo(thumb.dataset.videoSrc, thumb.dataset.src);
        } else {
          showImage(thumb.dataset.src, thumb.dataset.alt);
        }
      });
    });

    // Size / variant selection
    const variantInput  = document.getElementById('szph-variant-id');
    const priceEl       = document.getElementById('szph-price');
    const compareEl     = document.getElementById('szph-compare');
    const sizeCurrentEl = document.getElementById('szph-size-current');
    const sizeBtns      = document.querySelectorAll('.szph__size-btn');
    const ctaBtn        = document.getElementById('szph-cta');

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) { b.classList.remove('szph__size-btn--active'); });
        btn.classList.add('szph__size-btn--active');

        if (variantInput) variantInput.value = btn.dataset.variantId;
        if (priceEl)      priceEl.textContent = btn.dataset.price;
        if (sizeCurrentEl) sizeCurrentEl.textContent = btn.dataset.title;

        if (compareEl) {
          compareEl.textContent = btn.dataset.compare !== btn.dataset.price
            ? btn.dataset.compare
            : '';
        }
      });
    });

    // Inline size selector (product page)
    var inlineSizeBtns = document.querySelectorAll('.szph__inline-size-btn');
    inlineSizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        inlineSizeBtns.forEach(function (b) { b.classList.remove('szph__inline-size-btn--active'); });
        btn.classList.add('szph__inline-size-btn--active');
        if (variantInput) variantInput.value = btn.dataset.variantId;
        if (priceEl) priceEl.textContent = btn.dataset.price;
        if (sizeCurrentEl) sizeCurrentEl.textContent = btn.dataset.title;
        if (compareEl) {
          compareEl.textContent = (btn.dataset.compare && btn.dataset.compare !== btn.dataset.price)
            ? btn.dataset.compare : '';
        }
        selectedVariantId = btn.dataset.variantId;
        if (sizeError) sizeError.style.display = 'none';
      });
    });

    // Sticky bar visibility: hide when CTA is visible
    const ctaObserver = ctaBtn && window.IntersectionObserver
      ? new IntersectionObserver(function (entries) {
          const bar = document.getElementById('sz-sticky-bar');
          if (bar) bar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
        })
      : null;
    if (ctaObserver && ctaBtn) ctaObserver.observe(ctaBtn);

    // Pack modal
    const modal    = document.getElementById('szph-modal');
    const closeBtn = document.getElementById('szph-modal-close');
    const sizeError = document.getElementById('szph-size-error');

    // Build variant map from embedded product JSON
    var variantMap = {};
    try {
      var pj = document.getElementById('sz-product-json');
      if (pj) {
        JSON.parse(pj.textContent).variants.forEach(function (v) {
          var key = (v.title || '').toLowerCase().replace(/[\s\/]+/g, '-');
          variantMap[v.title] = v.id;
          variantMap[key] = v.id;
        });
      }
    } catch (e) {}

    var selectedVariantId = null;

    function resetModal() {
      var activeInline = document.querySelector('.szph__inline-size-btn--active');
      document.querySelectorAll('.szph-size-opt').forEach(function (b) {
        var match = activeInline && b.dataset.size === activeInline.dataset.title;
        b.classList.toggle('is-active', !!match);
      });
      if (sizeError) sizeError.style.display = 'none';
    }

    function openModal() {
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        resetModal();
      }
    }

    // Global entry point so external sections (sz-product-packs, etc.) can open the modal
    window.szOpenModal = function (qty) {
      window.szSelectedQty = qty || 1;
      openModal();
    };
    function closeModal() {
      if (modal) { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    // Size button selection
    document.querySelectorAll('.szph-size-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.szph-size-opt').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var sz = btn.dataset.size;
        var key = sz.toLowerCase().replace(/[\s\/]+/g, '-');
        selectedVariantId = variantMap[sz] || variantMap[key] || null;
        if (sizeError) sizeError.style.display = 'none';
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sz-product-packs"]) return;
  try {
    
  (function () {
    if (window.innerWidth > 640) return;
    var grid = document.getElementById('sz-prod-packs');
    var dotsEl = document.getElementById('sz-prod-packs-dots');
    if (!grid || !dotsEl) return;
    var dots = Array.from(dotsEl.querySelectorAll('.sz-dot'));
    function updateDots() {
      var gLeft = grid.getBoundingClientRect().left;
      var idx = 0, minDist = Infinity;
      Array.from(grid.children).forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - gLeft);
        if (d < minDist) { minDist = d; idx = i; }
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('sz-dot--active', i === idx); });
    }
    grid.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var child = grid.children[i];
        if (child) child.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sz-product-reviews"]) return;
  try {
    
  (function () {
    if (window.innerWidth > 768) return;
    var grid = document.getElementById('sz-prod-reviews');
    var dotsEl = document.getElementById('sz-prod-reviews-dots');
    if (!grid || !dotsEl) return;
    var dots = Array.from(dotsEl.querySelectorAll('[data-dot]'));
    var items = Array.from(grid.querySelectorAll('[data-carousel-item]'));
    function updateDots() {
      if (!items.length) return;
      var itemWidth = items[0].offsetWidth + 16;
      var idx = Math.round(grid.scrollLeft / itemWidth);
      idx = Math.max(0, Math.min(idx, dots.length - 1));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('sz-dot--active', i === idx);
        dot.style.opacity = i === idx ? '1' : '0.3';
      });
    }
    grid.addEventListener('scroll', updateDots, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var child = items[i];
        if (child) child.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });

    // Touch swipe support
    var touchStartX = 0;
    grid.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    grid.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        var cardWidth = items[0] ? items[0].offsetWidth + 16 : grid.offsetWidth;
        grid.scrollBy({ left: diff > 0 ? cardWidth : -cardWidth, behavior: 'smooth' });
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sz-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.innerWidth > 640) return;
    var grid = document.getElementById('sz-home-reviews');
    var dotsEl = document.getElementById('sz-home-reviews-dots');
    if (!grid || !dotsEl) return;
    var dots = Array.from(dotsEl.querySelectorAll('.sz-dot'));

    function updateDots() {
      var gLeft = grid.getBoundingClientRect().left;
      var idx = 0, minDist = Infinity;
      Array.from(grid.children).forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - gLeft);
        if (d < minDist) { minDist = d; idx = i; }
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('sz-dot--active', i === idx); });
    }

    grid.addEventListener('scroll', updateDots, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var child = grid.children[i];
        if (child) child.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });

    // Touch swipe support
    var touchStartX = 0;
    var touchStartScrollLeft = 0;

    grid.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartScrollLeft = grid.scrollLeft;
    }, { passive: true });

    grid.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        var cardWidth = grid.children[0] ? grid.children[0].offsetWidth + 12 : grid.offsetWidth;
        grid.scrollBy({ left: diff > 0 ? cardWidth : -cardWidth, behavior: 'smooth' });
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
